import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_3 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_4 = { class: "mt-0" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_6 = { class: "input-group top_search" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_8 = { class: "input-group top_search" };
const _hoisted_9 = { class: "col-sm-12 col-xxl-6" };
const _hoisted_10 = { class: "clearfix" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", null, "System", -1 /* HOISTED */);
const _hoisted_12 = { class: "input-group top_search" };
const _hoisted_13 = { class: "col-sm-12 col-xxl-6" };
const _hoisted_14 = { class: "clearfix" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", null, "Period", -1 /* HOISTED */);
const _hoisted_16 = {
    key: 0,
    class: "btn-group pw100 bottom10"
};
const _hoisted_17 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_22 = { class: "row" };
const _hoisted_23 = { class: "col-sm-12 col-xxl-6" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("label", null, "Discharge(s)", -1 /* HOISTED */);
const _hoisted_25 = {
    class: "charge-cycle-table-wrapper",
    style: { "height": "310px" }
};
const _hoisted_26 = {
    id: "chargeCycleTable",
    class: /*#__PURE__*/ _normalizeClass(['table-simple charge-cycle-table'])
};
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-arrow-up white-text" })
], -1 /* HOISTED */);
const _hoisted_28 = ["id", "onClick"];
const _hoisted_29 = { class: "text-center" };
const _hoisted_30 = ["title"];
const _hoisted_31 = { class: "data-grid-footer" };
const _hoisted_32 = {
    id: "second-column-parameters",
    class: "col-sm-12 col-xxl-6"
};
const _hoisted_33 = { class: "x_panel top10" };
const _hoisted_34 = { class: "x_content w-100" };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("h3", { class: "mt-0" }, "String(s)", -1 /* HOISTED */);
const _hoisted_36 = { class: "d-flex flex-wrap" };
const _hoisted_37 = { class: "me-3" };
const _hoisted_38 = { class: "x_panel top10" };
const _hoisted_39 = { class: "x_content" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("h3", { class: "mt-0" }, "Limits", -1 /* HOISTED */);
const _hoisted_41 = { class: "clearfix bottom10" };
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("label", null, "Block Voltage Low Limit (V): ", -1 /* HOISTED */);
const _hoisted_43 = { class: "clearfix bottom10" };
const _hoisted_44 = { class: "row mt-2" };
const _hoisted_45 = {
    key: 0,
    class: "col-sm-12"
};
const _hoisted_46 = { class: "x_panel" };
const _hoisted_47 = {
    class: "x_content",
    style: { "height": "auto", "width": "100%", "padding": "10px" }
};
const _hoisted_48 = { class: "clearfix" };
const _hoisted_49 = { class: "d-flex" };
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("label", { class: "text-nowrap me-3" }, "Duration Automatic:", -1 /* HOISTED */);
const _hoisted_51 = { class: "mb-2 d-flex" };
const _hoisted_52 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_53 = { class: "float-end" };
const _hoisted_54 = { class: "d-flex" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("label", { class: "text-nowrap me-3" }, "Display Chart: ", -1 /* HOISTED */);
const _hoisted_56 = {
    key: 0,
    class: "d-flex"
};
const _hoisted_57 = { class: "d-block" };
const _hoisted_58 = {
    class: "list-filter",
    style: { "width": "120px", "height": "420px", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_59 = { class: "list-options" };
const _hoisted_60 = ["onClick"];
const _hoisted_61 = { style: { "background": "white", "width": "100%", "height": "100%", "margin-left": "20px" } };
const _hoisted_62 = { class: "float-end float-start-sm" };
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_64 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_Toggle = _resolveComponent("Toggle");
    const _component_DischargeReportFilterGraphVue = _resolveComponent("DischargeReportFilterGraphVue");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                (_ctx.reportScheduledModel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("h2", _hoisted_4, [
                            _createTextVNode("Editing schedule report "),
                            _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedCompanyId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                        options: _ctx.companies,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "All companies",
                        class: "multiselect-small"
                    }, {
                        noResult: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedSite,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                        options: _ctx.sitesFiltered,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "Any site",
                        class: "multiselect-small"
                    }, {
                        noResult: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.system,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.system) = $event)),
                            options: _ctx.systemsFiltered,
                            "track-by": "systemId",
                            label: "displayName",
                            showLabels: false,
                            placeholder: _ctx.selectPlaceholderSystem,
                            class: _normalizeClass([_ctx.isSystemInvalid ? 'is-invalid' : ''])
                        }, {
                            noResult: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options", "placeholder", "class"])
                    ])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(),
                    (!_ctx.showDatePickers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                return _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                    class: "pw100",
                                    key: idx,
                                    variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                    onClick: ($event) => (_ctx.setDateFilterOption(item)),
                                    title: _ctx.getPeriodTitle(item)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant", "onClick", "title"])), [
                                    [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                    ]
                                ]);
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    (_ctx.showDatePickers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.startTime,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.startTime) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "Select date"
                                        }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group_append, null, {
                                            default: _withCtx(() => [
                                                _hoisted_19
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.endTime,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.endTime) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "Select date"
                                        }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group_append, null, {
                                            default: _withCtx(() => [
                                                _hoisted_21,
                                                _createTextVNode(),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-secondary",
                                                    onClick: _cache[5] || (_cache[5] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                }, "\r\n\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("table", _hoisted_26, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_27,
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'SnapshotDate', title: 'Date' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'Duration', title: 'Duration' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'ComponentNames', title: 'Strings' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chargeCycleSnapshots.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    id: 'snapshot-' + item.snapshotId,
                                    onClick: ($event) => (_ctx.selectChargeCycleSnapshot(item)),
                                    class: _normalizeClass(_ctx.getChargeCycleSnapshotClass(item))
                                }, [
                                    _createElementVNode("td", _hoisted_29, [
                                        _withDirectives((_openBlock(), _createElementBlock("div", {
                                            title: _ctx.snapshotTypeDescriptionString(item)
                                        }, [
                                            _createElementVNode("i", {
                                                class: _normalizeClass(_ctx.snapshotTypeString(item))
                                            }, null, 2 /* CLASS */)
                                        ], 8 /* PROPS */, _hoisted_30)), [
                                            [
                                                _directive_b_tooltip,
                                                void 0,
                                                void 0,
                                                { hover: true }
                                            ]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.snapshotDateString(item)), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", null, _toDisplayString(item.durationText), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.componentNamesString(item)), 1 /* TEXT */)
                                ], 10 /* CLASS, PROPS */, _hoisted_28));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_b_pagination, {
                        class: "float-end no-margin",
                        size: "sm",
                        modelValue: _ctx.chargeCycleSnapshotsQuery.pageNo,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.chargeCycleSnapshotsQuery.pageNo) = $event)),
                        "per-page": _ctx.chargeCycleSnapshotsQuery.pageSize,
                        "total-rows": _ctx.chargeCycleSnapshots.recordCount,
                        "hide-ellipsis": true,
                        disabled: _ctx.working
                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stringsList, (item) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createVNode(_component_b_form_checkbox, {
                                        modelValue: item.selected,
                                        "onUpdate:modelValue": ($event) => ((item.selected) = $event)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"])
                                ]));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createTextVNode(),
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.overrideLimits,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.overrideLimits) = $event))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("Override Limits")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createTextVNode(),
                            _createVNode(_component_b_form_input, {
                                type: "number",
                                modelValue: _ctx.blockVoltageLowLimit,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.blockVoltageLowLimit) = $event)),
                                modelModifiers: { trim: true },
                                disabled: !_ctx.overrideLimits,
                                class: _normalizeClass([_ctx.isBlockVoltageLowLimitInvalid ? 'is-invalid' : ''])
                            }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("label", null, "Block Temperature High Limit (" + _toDisplayString(_ctx.getTemperatureUoM) + "): ", 1 /* TEXT */),
                            _createTextVNode(),
                            _createVNode(_component_b_form_input, {
                                type: "number",
                                modelValue: _ctx.blockTemperatureHighLimit,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.blockTemperatureHighLimit) = $event)),
                                modelModifiers: { trim: true },
                                disabled: !_ctx.overrideLimits,
                                class: _normalizeClass([_ctx.isBlockTemperatureHighLimitInvalid ? 'is-invalid' : ''])
                            }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"])
                        ])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_44, [
            (_ctx.isChartAvailable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                    _hoisted_50,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_51, [
                                        _createVNode(_component_Toggle, {
                                            modelValue: _ctx.automaticDuration,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.automaticDuration) = $event)),
                                            class: "me-2"
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.automaticDuration)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                            _createElementVNode("div", _hoisted_53, [
                                                _createElementVNode("div", _hoisted_54, [
                                                    _hoisted_55,
                                                    _createTextVNode(),
                                                    _createVNode(_component_Toggle, {
                                                        modelValue: _ctx.displayChart,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.displayChart) = $event)),
                                                        class: "me-2"
                                                    }, null, 8 /* PROPS */, ["modelValue"])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.displayChart || !_ctx.automaticDuration)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventsDateTimeList, (item) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass(['list-option', _ctx.isDateTimeSelected(item) ? 'selected-option' : '']),
                                                        onClick: ($event) => (_ctx.selectDate(item)),
                                                        style: { "text-align": "center", "padding": "2px" }
                                                    }, [
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.getHourFromDateItem(item)), 1 /* TEXT */)
                                                    ], 10 /* CLASS, PROPS */, _hoisted_60));
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                            ])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_61, [
                                        (_openBlock(), _createBlock(_component_DischargeReportFilterGraphVue, {
                                            key: _ctx.componentKey,
                                            chartData: _ctx.chartData,
                                            options: _ctx.chartOptions,
                                            height: 420
                                        }, null, 8 /* PROPS */, ["chartData", "options"]))
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_62, [
            _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.schedule
            }, {
                default: _withCtx(() => [
                    _hoisted_63,
                    _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
                [_directive_standard_or_higher]
            ]),
            _createTextVNode(),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToPdf
            }, {
                default: _withCtx(() => [
                    _hoisted_64,
                    _createTextVNode(" Export PDF\r\n\t\t")
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
        ]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
